<template>
  <div style="
      background: linear-gradient(
        135deg,
        rgb(25 115 165),
        rgb(20 145 215),
        #0d67aa,
        #00304e
      );
    ">
    <v-list>
      <v-list-item link>
        <v-list-item-content class="d-flex align-center" style="flex-wrap: nowrap;">
          <div>
            <!-- <v-list-item-title class="text-h6">CNSR</v-list-item-title> -->
            <v-img :src="require('../../assets/logo_cnsr_blanco.png')" max-width="200" max-height="100" class="ml-3"
              style="margin-left:.5rem  !important ;"></v-img>
          </div>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-divider></v-divider>
    <v-list nav dense>
      <v-list-item-group color="primary">
        <div v-for="(item, i) in itemsNavBarAdmision" :key="i">
          <router-link v-if="!item.children" :key="i" :to="item.route" exact>
            <v-list-item :class="{
              'v-list-item-navbar': true,
              'v-list-item--active': isExactActive(item.route),
            }">
              <v-list-item-icon>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ item.text }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>
          <v-list-group :value="isGroupActive(item.children)" prepend-icon="mdi-folder" v-if="item.children"
            style="color: #ffff !important" color="#ffff">
            <template v-slot:activator>
              <v-list-item-title style="color: #ffff !important" color="#ffff">{{ item.text }}</v-list-item-title>
            </template>
            <div class="ml-6">
              <router-link v-for="(child, j) in item.children" :key="j" :to="child.route" exact>
                <v-list-item :class="{
                  'v-list-item-navbar': true,
                  'v-list-item--active': isExactActive(child.route),
                }">
                  <v-list-item-icon>
                    <v-icon>{{ child.icon }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{ child.text }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </router-link>
            </div>
          </v-list-group>
        </div>
      </v-list-item-group>
    </v-list>
  </div>
</template>
<style scoped>
.v-list-group--active>.v-list-group__header .v-list-group__header__prepend-icon .v-icon {
  color: rgb(255, 255, 255) !important;
}

::v-deep .theme--light.v-icon {
  color: rgb(255, 255, 255) !important;
}

.v-icon.v-icon {
  color: rgb(255, 255, 255) !important
}

.theme--light.v-icon:before {
  color: rgb(255, 255, 255) !important;
}

.theme--light.v-list-item .v-list-item__subtitle,
.theme--light.v-list-item .v-list-item__action-text {
  color: rgba(255, 255, 255, 0.6) !important;
}

.theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
  color: rgb(255, 255, 255) !important;
}

.v-icon.notranslate.mdi.mdi-folder.theme--light,
.v-list-item__icon.v-list-group__header__prepend-icon .v-icon {
  color: rgb(255, 255, 255) !important;
}

.v-icon.v-icon {
  color: rgb(255, 255, 255) !important;
}

.v-icon {
  color: rgb(255, 255, 255) !important;
}

.v-list-item--link:before {
  background: transparent !important;
}

.router-link-exact-active.router-link-active .v-list-item--active {
  background-color: #ffffff3b;
  color: #ffffff !important;
  font-weight: 400 !important;
}

.v-list-group div,
.v-list-item-navbar.v-list-item {
  color: #ffffff !important;
  font-weight: 400 !important;
}

.v-list-item-navbar {
  transition: background-color 0.3s, color 0.3s;
}

.v-list-item__title {
  text-align: left;
  font-weight: 400 !important;
}

.v-list-item__icon .v-icon.notranslate.mdi.mdi-folder.theme--light,
.v-list-item__icon .v-icon.notranslate.mdi.mdi-folder.theme--light,
.v-list-item__icon.v-list-group__header__prepend-icon .v-icon {
  color: white !important;
}

a {
  text-decoration: none;
}

.v-list-group {
  color: white !important;
}

.v-divider.theme--light {
  border-color: rgba(255, 255, 255, 0.543) !important;
}

s .v-list-item__icon .v-icon.notranslate.mdi.mdi-folder.theme--light,
.v-list-item__icon .v-icon.notranslate.mdi.mdi-folder.theme--light,
.v-list-item__icon.v-list-group__header__prepend-icon .v-icon {
  color: white !important;
  text-decoration: none;
}

.v-list-group {
  color: white !important;
}

.v-list-item-navbar:hover {
  background-color: #ffffff10;
}
</style>
<script>
import Swal from "sweetalert2";
import { mapState } from "vuex";
export default {
  name: "navBarV",
  props: ["selectedItemBar"],
  data() {
    return {
      openGroups: [],
      status: false,
      selectedItem: null,
      itemModalidad: null,
      itemPeriodo: null,
      itemsNavBarAdmision: [
        {
          text: "Parametrización", icon: "mdi-cog", route: "",
          children: [
            { text: "Hospitales", icon: "mdi-hospital-building", route: "/admision/hospitales" },
            { text: "Medicos", icon: "mdi-doctor", route: "/admision/medicos" },
            { text: "Bloqueo cupos", icon: "mdi-lock", route: "/admision/cupo_bloqueo" },
            { text: "Cupos", icon: "mdi-chair-school", route: "/admision/cupos" },
            { text: "Bloqueo pacientes", icon: "mdi-account-lock", route: "/admision/bloquear_paciente" }
          ],
        },
        { text: "Registro paciente", icon: "mdi-account-plus", route: "/admision/registroPaciente" },
        { text: "Lista de espera", icon: "mdi-format-list-bulleted", route: "/admision/listaEspera" },
        { text: "Movimientos", icon: "mdi-swap-horizontal", route: "/admision/movimientos" },
        {
          text: "Reportes",
          icon: "mdi-file-chart",
          route: "",
          children: [
            { text: "Cupos disponibles", icon: "mdi-chair-school", route: "/admision/cup_disponibles" },
            { text: "Asistencia pacientes", icon: "mdi-account-check", route: "/admision/asistencia" },
            { text: "Nuevos ingresos", icon: "mdi-account-multiple-plus", route: "/admision/nuevos-ingresos" },
            { text: "Resumen producción", icon: "mdi-chart-bar", route: "/admision/resumen-produccion" },
            { text: "Informe nutrición", icon: "mdi-food-apple-outline", route: "/admision/nutricion" }
          ],
        }
      ],
    };
  },
  watch: {
    $route() {
      // Fuerza la actualización del componente cuando la ruta cambia
      this.$forceUpdate();
      console.log("me estoy ejecuentado");
    },
  },
  computed: {
    /*  ...mapState({
       activeRoute: (state) => state.activeRoute,
     }), */
  },
  methods: {
    executeAction(actionName) {
      if (this[actionName] && typeof this[actionName] === 'function') {
        this[actionName]();
      } else {
        console.error(`${actionName} is not a function`);
      }
    },
    NuevosIngresos() {
      console.log("gashdiashfijahsffafas")
    },
    ResumenProduccion() {
      console.log("asassssssss")
    },
    isExactActive(route) {
      return this.$route.path === route;
    },
    isGroupActive(children) {
      return children.some((child) => this.$route.path.startsWith(child.route));
    },
    toggleGroup(group) {
      if (this.openGroups.includes(group)) {
        this.openGroups = this.openGroups.filter((g) => g !== group);
      } else {
        this.openGroups.push(group);
      }
    },
    isGroupOpen(group) {
      return this.openGroups.includes(group);
    },
    isActive(route) {
      return this.$route.path === route;
    },
    updateItem(tipo, index) {
      const body = { index: index, tipo: tipo };
      this.status = !this.status;
      this.$emit("updateItemBar", body);
    },
  },
  created() {
    this.perfil = sessionStorage.getItem("perfil");
    this.nombre = sessionStorage.getItem("nombre");
  },
};
</script>